import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import defaultHeaders from './default-headers';

/**
 * Post request function
 * @param {string} url - The url
 * @param {any} [data] - The data
 * @param {boolean} [isFileUpload] - The isFileUpload
 * @param {AxiosRequestConfig} [config] - Optional axios request configuration
 * @returns {Promise<AxiosResponse<any>>} The axios response promise
 */
const postRequest = async (
  url: string,
  data?: any,
  isFileUpload = false,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<any>> => {
  try {
    const customHeaders: Record<string, string> = isFileUpload
      ? { 'Content-Type': 'multipart/form-data' }
      : {};

    const authToken = defaultHeaders();
    const headers = {
      ...(authToken && authToken), // Add Authorization header if token exists
      ...customHeaders,
      ...config?.headers,
    };

    console.log('[postRequest] Sending POST request to:', url);
    console.log('[postRequest] Data:', data);
    console.log('[postRequest] Headers:', headers);

    return await axios.post(url, data, { ...config, headers });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default postRequest;
